
    import Vue from "vue";

    const END_POINT = "/inventory-lab-result";

    const getInventoryLabResult = id => Vue.axios.get(END_POINT + "/" + id);

    const getAllInventoryLabResults = data => Vue.axios.get(END_POINT, {params: data});

    const createInventoryLabResult = inventoryLabResult => Vue.axios.post(END_POINT,  inventoryLabResult );

    const createAllInventoryLabResults = inventoryLabResults => Vue.axios.post(END_POINT + "/all",  inventoryLabResults );

    const parseLabResultPdf = file => {
      const form = new FormData();
      form.append("file", file);
      return Vue.axios.post(END_POINT + "/parse-pdf", form, {
        headers: { "Content-Type": "multipart/form-data" }
      });
    };

    // Retry inventory matching for still-unassigned results tested in the date range.
    // The page sends at most a month per call; the longer limit is a safety margin for a month
    // with many reports to fix, not a reason to send more.
    const autoAssignInventoryLabResults = params => Vue.axios.post(END_POINT + "/auto-assign", null, { params, timeout: 5 * 60 * 1000 });

    const updateInventoryLabResult = inventoryLabResult => Vue.axios.put(END_POINT  + "/" + inventoryLabResult.id,  inventoryLabResult );

    const deleteInventoryLabResult = id => Vue.axios.delete(END_POINT  + "/" + id);

    export {
      getInventoryLabResult,
      getAllInventoryLabResults,
      createInventoryLabResult,
      createAllInventoryLabResults,
      updateInventoryLabResult,
      deleteInventoryLabResult,
      parseLabResultPdf,
      autoAssignInventoryLabResults
    };
    